import "./AlertMessage.styles.scss";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, IconButton } from "@mui/material";

export interface IAlertMessageProps {
  id: string;
  message: string;
  status: number;
  closeAlertMessage: (id: string) => void;
  onClickText?: string;
  onClickMethod?: () => void;
}

const AlertMessage = ({
  id,
  message,
  status,
  closeAlertMessage,
  onClickText,
  onClickMethod,
}: IAlertMessageProps) => {
  const getVariantFromStatus = (status: number) => {
    switch (status) {
      case 200:
        return {
          variant: "success",
          color: "#119436",
        };
      case 404:
      case 408:
      case 300:
        return {
          variant: "warning",
          color: "#fb7d1b",
        };
      case 500:
        return {
          variant: "danger",
          color: "#e70a16",
        };
      default:
        return {
          variant: "info",
          color: "#3e66a7",
        };
    }
  };

  const variant_details = getVariantFromStatus(status);

  return (
    <Alert
      variant="filled"
      sx={{
        backgroundColor: `${variant_details.color}`,
        color: "white",
      }}
      icon={
        variant_details.variant === "success" ? (
          <AddAlertIcon />
        ) : (
          <NotificationImportantIcon />
        )
      }
      className="alert-message"
      action={
        <IconButton
          size="small"
          className="alert-message-icon-button"
          onClick={() => closeAlertMessage(id)}
        >
          <CloseIcon />
        </IconButton>
      }
    >
      {message}
      {onClickText && onClickMethod && (
        <span
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={onClickMethod}
        >
          {onClickText}
        </span>
      )}
    </Alert>
  );
};

export default AlertMessage;
